import styled from 'styled-components';

export const StyledDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-top: 4.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    margin-top: 8rem;
  }
`;

export const StyledImagesContainer = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: auto auto auto;
  padding-inline: 1.6rem;
  gap: 2.4rem;
  margin-top: 4.6rem;

  @media screen and (min-width: ${({ theme }) => theme.sizes.md}) {
    grid-template-columns: 1fr 1fr 1fr;
    grid-template-rows: auto auto;
  }

  @media screen and (min-width: ${({ theme }) => theme.sizes.lg}) {
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  }
`;

export const StyledImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1.4rem;
`;

export const StyledImage = styled.img`
  width: 12.4rem;
  height: 12.4rem;
`;

export const StyledImageTitle = styled.span`
  font-family: ${({ theme }) => theme.fonts.familySansPro};
  font-size: ${({ theme }) => theme.fonts.sizes.default};
  font-weight: ${({ theme }) => theme.fonts.weight.regular};
  line-height: ${({ theme }) => theme.fonts.lineHeight.default};
  color: ${({ theme }) => theme.colors.grey[900]};
  text-align: center;
`;
